import { Overlay } from '@angular/cdk/overlay';
import { ComponentPortal, PortalInjector } from '@angular/cdk/portal';
import { ApplicationRef, ComponentFactoryResolver, InjectionToken, Injector } from '@angular/core';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common";
import * as i2 from "@angular/cdk/overlay";
export var CONTAINER_DATA = new InjectionToken('CONTAINER_DATA');
var FloatPopupService = /** @class */ (function () {
    function FloatPopupService(document, _appRef, _componentFactoryResolver, _injector, _overlay) {
        this.document = document;
        this._appRef = _appRef;
        this._componentFactoryResolver = _componentFactoryResolver;
        this._injector = _injector;
        this._overlay = _overlay;
        // floatPopupBS: BehaviorSubject<{open: boolean}> = new BehaviorSubject({
        // 	open: false
        // });
        // _overlayRef: OverlayRef;
        this._overlayRefs = {};
    }
    // openFloatPopup() {
    // 	this.floatPopupBS.next({
    // 		open: true
    // 	})
    // }
    // closeFloatPopup() {
    // 	this.floatPopupBS.next({
    // 		open: false
    // 	})
    // }
    FloatPopupService.prototype.openPopup = function (component, dataToPass, panelClassList) {
        if (this._overlayRefs[component]) {
            return;
        }
        var classList = ['float-popup-container'];
        if (panelClassList) {
            panelClassList.forEach(function (i) { return classList.push(i); });
        }
        var overlayRef = this._overlay.create({
            panelClass: classList
        });
        var injector = dataToPass ? this.createInjector(dataToPass) : null;
        var containerComponentPortal = new ComponentPortal(component, null, injector);
        var containerRef = overlayRef.attach(containerComponentPortal);
        this._overlayRefs[component] = overlayRef;
        // const portalOutlet = new DomPortalOutlet(
        // 	containerRef.instance.VCR.element.nativeElement,
        // 	this._componentFactoryResolver,
        // 	this._appRef,
        // 	this._injector
        //   )
        // portalOutlet.attachComponentPortal(new ComponentPortal(component));
        // containerComponentPortal.attach(portalOutlet);
    };
    FloatPopupService.prototype.closePopup = function (component) {
        this._overlayRefs[component].detach();
        delete this._overlayRefs[component];
    };
    FloatPopupService.prototype.closeAll = function () {
        var _this = this;
        Object.keys(this._overlayRefs).forEach(function (c) { return _this.closePopup(c); });
    };
    FloatPopupService.prototype.createInjector = function (dataToPass) {
        var injectorTokens = new WeakMap();
        injectorTokens.set(CONTAINER_DATA, dataToPass);
        return new PortalInjector(this._injector, injectorTokens);
    };
    FloatPopupService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function FloatPopupService_Factory() { return new FloatPopupService(i0.ɵɵinject(i1.DOCUMENT), i0.ɵɵinject(i0.ApplicationRef), i0.ɵɵinject(i0.ComponentFactoryResolver), i0.ɵɵinject(i0.INJECTOR), i0.ɵɵinject(i2.Overlay)); }, token: FloatPopupService, providedIn: "root" });
    return FloatPopupService;
}());
export { FloatPopupService };
